import { createAction, props } from '@ngrx/store';

export const ButtonPointerEventEnabled = createAction(
  '[Bulk Operations: New Bulk Configuration]: Button Pointer Event Enabled',
);

export const ButtonPointerEventDisabled = createAction(
  '[Bulk Operations: New Bulk Configuration]: Button Pointer Event Disabled',
);

export const DropZoneEnabled = createAction(
  '[Bulk Operations: New Bulk Configuration]: Drop Zone Enabled',
);

export const DropZoneDisabled = createAction(
  '[Bulk Operations: New Bulk Configuration]: Drop Zone Disabled',
);

export const UploadedFileChanged = createAction(
  '[Bulk Operations: New Bulk Configuration]: Uploaded File Changed',
  props<{ name: string; size: number; lines: number }>(),
);

export const FileReaderError = createAction(
  '[Bulk Operations: New Bulk Configuration]: File Reader Error',
);

export const GetFile = createAction(
  '[Bulk Operations: New Bulk Configuration]: Get File',
  props<{ file: any }>(),
);

export const GetDisplayedColumns = createAction(
  '[Bulk Operations: New Bulk Configuration]: Get Displayed Columns',
  props<{ cols: number }>(),
);

export const GetFileTableRows = createAction(
  '[Bulk Operations: New Bulk Configuration]: Get File Table Rows',
  props<{ fileTableRows: any }>(),
);

export const RemoveFile = createAction('[Bulk Operations: New Bulk Configuration]: Remove File');

export const DryRunChanged = createAction(
  '[Bulk Operations: New Bulk Configuration]: Dry Run Changed',
);

export const EmptyNewBulkOp = createAction(
  '[Bulk Operations: New Bulk Configuration]: Empty New Bulk Operation',
);

export const FileToUploadChanged = createAction(
  '[Bulk Operations: New Bulk Configuration]: File To Upload Changed',
  props<{ fileToUpload: any }>(),
);

export const UploadingFile = createAction(
  '[Bulk Operations: New Bulk Configuration]: Uploading File',
);
